import React from "react";
import styled from "styled-components";
// import axios from "axios";

export default function DataTable({data}){
    
    // const columns = data[0] && Object.keys(data[0])
    const columns = ["date", "location", "sender", "tag_string", "price"]
    const column_names = ["Date", "Location", "Sender", "Tags", "Price", ""]
    const base_url = "https://cvkdl78x74.execute-api.us-east-1.amazonaws.com/production/file_url/"
    async function downloadFile(s3_key) {

        
        
        const api_url = base_url + s3_key.trim() + "/"

        const response = await fetch(api_url);
        const data = await response.json();

        console.log("Downloading File " + s3_key + "\napi endpoint " + api_url)
        
        window.open(data[0]["filedata"], "_blank")

        console.log("Downloading File " + s3_key + "\napi endpoint " + api_url)
        }

    return (

        <Table cellPadding={0} cellSpacing={20}>
            <thead>
                <tr>{data[0] && column_names.map((header, idx) => 
                        {
                           return (
                                <th key={idx}>
                                    {header}
                                </th>
                            )
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data.map((row, idx) => 
                        {
                            return (
                                <tr key={idx}>
                                    {columns.map((column, idx) => <td key={idx}>{row[column]}</td>)}
                                    {row["file_string"].split(",").map((string, idx) => {
                                        return (<td> 
                                            <button className="button" type="button" onClick={() => downloadFile(string)} > 
                                                {row["file_string"].split(",").length > 1 ? "download file " + idx  : "download file"}
                                            </button>
                                        </td>)        
                                    })}
                                </tr>

                            )
                        })
                }
            </tbody>

        </Table>
    )
}

const Table = styled.table`
    /* color:red; */
    .button{
        color:var(--font-light-color);
        position:relative;
        font-size: 70%;
        float:right;
        text-align: center;
        padding: .5rem;
        border-radius: .5rem;
        background-color: var(--primary-color);
      }
`;